import { missingValue } from "./missingValue.js";

export function toPercentageString(fractionValue: number): string {
  return fractionValue === missingValue
    ? "-"
    : Math.round(100 * fractionValue) + "%";
}
